module.exports = __webpack_public_path__ + "pc/img/work_list4.61533ce3.jpg";